(function(){
  function init(root){
    root.querySelectorAll('.bm-family-ownership').forEach(function(section){
      if(section.dataset.helpReady)return;
      const dialog=section.querySelector('.bm-family-help');
      if(!dialog||typeof dialog.showModal!=='function')return;
      section.dataset.helpReady='true';
      const title=dialog.querySelector('[data-bm-help-title]');
      const content=dialog.querySelector('[data-bm-help-content]');
      let trigger,previousOverflow;
      const links=Array.from(section.querySelectorAll('[data-bm-ownership-modal]')).concat(Array.from(root.querySelectorAll('[data-bm-delivery-help][aria-controls="'+dialog.id+'"]')));
      links.forEach(function(link){
        link.addEventListener('click',function(event){
          const template=Array.from(section.querySelectorAll('template[data-bm-help-page]')).find(function(item){return item.dataset.bmHelpPage===link.dataset.bmOwnershipModal;});
          if(!template)return;
          event.preventDefault();
          trigger=link;
          title.textContent=link.textContent;
          content.replaceChildren(template.content.cloneNode(true));
          content.querySelectorAll('a[href]').forEach(function(anchor){
            if(!anchor.getAttribute('href').startsWith('#')){anchor.target='_blank';anchor.rel='noopener';}
          });
          previousOverflow=document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow='hidden';
          content.scrollTop=0;
        });
      });
      dialog.querySelector('[data-bm-help-close]').addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('click',function(event){
        if(event.target!==dialog)return;
        const rect=dialog.getBoundingClientRect();
        if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
      });
      dialog.addEventListener('close',function(){
        document.body.style.overflow=previousOverflow;
        content.replaceChildren();
        if(trigger&&trigger.isConnected)trigger.focus({preventScroll:true});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

